
import { Box, Checkbox, FormControl, FormControlLabel, Unstable_Grid2 as Grid, Icon, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../stores/hooks";
import { setcurrentmenu } from "../../stores/menuslice";
import { DropdownModel, TableInfo } from "../../data/interfaces/sharedmodels";
import bulkimportService from "../../data/api/bulkimport.service";
import BulkImportEditableDatatables from "./childcomponents/editabledatatables";

export default function BulkImport() {
    const dispatch = useAppDispatch();
    const [datatables, setDatatables] = useState<TableInfo[]>([]);
    const [selectedDatatable, setSelectedDatatable] = useState<TableInfo|null>(null);
    const [tocs, setTocs] = useState<DropdownModel[]>([]);
    const [selectedTocs, setSelectedTocs] = useState<DropdownModel[]>([]);
    useEffect(() => {
        dispatch(setcurrentmenu('bulkimport'));
        bulkimportService.getDataTables().then((response) => {
            setDatatables(response.data);
        });
        bulkimportService.getTocs().then((response) => {
            setTocs(response.data);
        })

    }, []);

    useEffect(() => {
        if (datatables.length && !selectedDatatable) {
            setSelectedDatatable(datatables[0]);
        }
    }, [datatables]);

    const handleToggleToc = (checked: boolean, toc: DropdownModel) => {
        let tempSelectedTocs = [...selectedTocs];

        if (checked && tempSelectedTocs.findIndex(a => a.Id == toc.Id) < 0)
            tempSelectedTocs.push(toc);
        else if (!checked && tempSelectedTocs.findIndex(a => a.Id == toc.Id) > -1)
            tempSelectedTocs.splice(tempSelectedTocs.findIndex(a => a.Id == toc.Id), 1);
        setSelectedTocs(tempSelectedTocs);
    }

    const handleSelectAllChange = (checked: boolean) => {
        if (checked) {
            setSelectedTocs(tocs);
        }
        else {
            setSelectedTocs([]);
        }

    }


    return (
        <Box sx={{ m: 2 }}>
            <Grid container spacing={2} >
                <Grid xs={3} maxHeight={500}>
                    <Box component={Paper} padding={2}>
                        <Typography variant="h6" sx={{mb:2}}>DataTables</Typography>
                        <List disablePadding={true}>
                            {
                                datatables.map(function (table) {
                                    return (
                                        <ListItemButton key={table.Id} selected={selectedDatatable?.Id === table.Id}
                                            onClick={(event) => setSelectedDatatable(table)}>
                                            <ListItemText primary={table.Description} />
                                        </ListItemButton>)
                                })
                            }
                        </List>
                    </Box>
                </Grid>
                <Grid xs={3} maxHeight={500}>
                    <Box component={Paper} padding={2}>
                        <Typography variant="h6">TOCs</Typography>
                        <FormControlLabel sx={{ ml: .5 }} control={<Checkbox sx={{pr:4}} onChange={(event) => handleSelectAllChange(event.target.checked)} checked={tocs.length == selectedTocs.length} />} label='Select All' />
                        <List disablePadding={true}>
                            {
                                tocs.map(function (toc) {
                                    return (
                                        <ListItemButton key={toc.Id}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    onChange={(e) => handleToggleToc(e.target.checked, toc)}
                                                    checked={selectedTocs.findIndex(b => b.Id == toc.Id) > -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ 'aria-labelledby': toc.Description }} />
                                            </ListItemIcon>
                                            <ListItemText primary={toc.Description} />
                                        </ListItemButton>)
                                })
                            }
                        </List>
                    </Box>
                </Grid>
                <Grid xs={6}>
                    {selectedDatatable&&tocs.length?
                    <BulkImportEditableDatatables table={selectedDatatable} tocs={selectedTocs}/>:null}
                </Grid>
            </Grid>

        </Box>
    )
}